enum ConversationStatus {
	WorkerCreated = 10,
	AgencyUserCreated = 20,
	WorkerWaiting = 30,
	AgencyUserWaiting = 40,
	NoActionRequired = 50,
	Inactive = 91,
	Archived = 99,
}

export default ConversationStatus;